'use strict';


var preloader = require('spa-preloader'),

    Panel      = require('mag-component-panel'),
    ScrollBar  = require('stb-component-scrollbar'),
    ScrollArea = require('mag-component-scroll-area'),

    //footer = require('./footer'),

    panel    = new Panel({
        title: gettext('Info'),
        children: [],
        className: 'rightPanel'
    }),
    scroll   = new ScrollBar(),
    textArea = new ScrollArea({
        propagate: true,
        step: 5,
        scroll: scroll
    });


panel.add(textArea, scroll);

textArea.$body.$preview = textArea.$body.appendChild(document.createElement('canvas'));
textArea.$body.$preview.className = 'preview';
textArea.$body.$text = textArea.$body.appendChild(document.createElement('div'));
textArea.$body.$text.className = 'text';


panel.setInfo = function ( config ) {
    var $fragment;

    textArea.$body.$text.innerHTML = '';
    if ( config.preview ) {
        preloader.add([config.preview]);
        preloader.once('link', function () {
            textArea.$body.$preview.style.backgroundImage = 'url("' + config.preview + '")';
            textArea.$body.$preview.classList.remove('hidden');
        });
    } else {
        textArea.$body.$preview.classList.add('hidden');
    }

    if ( typeof config.description === 'string' ) {
        textArea.$body.$text.innerText = config.description;
    } else if ( config.description && config.description.length ) {
        // array of values
        $fragment = document.createDocumentFragment();
        config.description.forEach(function ( item ) {
            var $node = $fragment.appendChild(document.createElement('span'));

            $node.className = 'theme-subhead-color';
            $node.innerText = item.label + ' ';

            $node = $fragment.appendChild(document.createElement('span'));
            $node.className = '';
            $node.innerText = item.value;

            $fragment.appendChild(document.createElement('br'));
        });
        textArea.$body.$text.appendChild($fragment);
    }

    textArea.init();
};


module.exports = panel;
